<template>
    <div name="date-picker-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose"></div>
            <div class="contents">
                <span class="title">날짜 선택</span>
                <div class="calendar-header">
                    <img
                        class="arrow-btn"
                        src="../../assets/arrow_left.png"
                        @click="prevMonth"
                    />
                    <span class="month-text">{{ currentYear }}년 {{ currentMonth }}월</span>
                    <img
                        class="arrow-btn"
                        src="../../assets/arrow_right.png"
                        @click="nextMonth"
                    />
                </div>
                <div class="calendar-weekdays">
                    <span class="weekday sun">일</span>
                    <span class="weekday">월</span>
                    <span class="weekday">화</span>
                    <span class="weekday">수</span>
                    <span class="weekday">목</span>
                    <span class="weekday">금</span>
                    <span class="weekday sat">토</span>
                </div>
                <div class="calendar-days">
                    <div
                        v-for="(day, index) in calendarDays"
                        :key="index"
                        class="day-cell"
                        :class="{
                            'empty': day === null,
                            'selected': isSelected(day),
                            'today': isToday(day),
                            'sun': index % 7 === 0 && day !== null,
                            'sat': index % 7 === 6 && day !== null
                        }"
                        @click="selectDay(day)"
                    >
                        <span v-if="day !== null">{{ day }}</span>
                    </div>
                </div>
                <div class="button-area">
                    <div class="button-confirm" @click="onConfirm">선택 완료</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'datePickerModal',
    props: ['initialDate'],
    data() {
        const today = new Date();
        return {
            currentYear: today.getFullYear(),
            currentMonth: today.getMonth() + 1,
            selectedYear: today.getFullYear(),
            selectedMonth: today.getMonth() + 1,
            selectedDay: today.getDate()
        }
    },
    computed: {
        calendarDays() {
            const days = [];
            const firstDay = new Date(this.currentYear, this.currentMonth - 1, 1);
            const lastDay = new Date(this.currentYear, this.currentMonth, 0);
            const startDayOfWeek = firstDay.getDay();
            const totalDays = lastDay.getDate();

            // 시작 빈 칸
            for (let i = 0; i < startDayOfWeek; i++) {
                days.push(null);
            }

            // 해당 월의 일수
            for (let i = 1; i <= totalDays; i++) {
                days.push(i);
            }

            // 항상 6주(42칸)를 표시하도록 끝에 빈 칸 추가
            while (days.length < 42) {
                days.push(null);
            }

            return days;
        }
    },
    mounted() {
        if (this.initialDate && /^\d{4}-\d{2}-\d{2}$/.test(this.initialDate)) {
            const parts = this.initialDate.split('-');
            this.currentYear = parseInt(parts[0]);
            this.currentMonth = parseInt(parts[1]);
            this.selectedYear = parseInt(parts[0]);
            this.selectedMonth = parseInt(parts[1]);
            this.selectedDay = parseInt(parts[2]);
        }
    },
    methods: {
        prevMonth() {
            if (this.currentMonth === 1) {
                this.currentMonth = 12;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }
        },
        nextMonth() {
            if (this.currentMonth === 12) {
                this.currentMonth = 1;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }
        },
        selectDay(day) {
            if (day === null) return;
            this.selectedYear = this.currentYear;
            this.selectedMonth = this.currentMonth;
            this.selectedDay = day;
        },
        isSelected(day) {
            return day !== null &&
                this.selectedYear === this.currentYear &&
                this.selectedMonth === this.currentMonth &&
                this.selectedDay === day;
        },
        isToday(day) {
            const today = new Date();
            return day !== null &&
                today.getFullYear() === this.currentYear &&
                today.getMonth() + 1 === this.currentMonth &&
                today.getDate() === day;
        },
        formatDate() {
            const month = String(this.selectedMonth).padStart(2, '0');
            const day = String(this.selectedDay).padStart(2, '0');
            return `${this.selectedYear}-${month}-${day}`;
        },
        onClose() {
            this.$emit('onClose');
        },
        onConfirm() {
            this.$emit('onConfirm', this.formatDate());
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10000;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        box-sizing: border-box;
    }
    .touch {
        height: calc(100vh - 530px);
        width: 100%;
    }
    .contents {
        background: #FFFFFF;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 30px 16px 50px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
    }
    .calendar-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 24px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .arrow-btn {
        width: 24px;
        height: 24px;
        cursor: pointer;
        padding: 8px;
    }
    .month-text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 18px;
        font-weight: 600;
        line-height: normal;
    }
    .calendar-weekdays {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        padding-bottom: 12px;
        border-bottom: 1px solid #EDEEF0;
    }
    .weekday {
        width: calc(100% / 7);
        text-align: center;
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 14px;
        font-weight: 400;
    }
    .weekday.sun {
        color: #FF000F;
    }
    .weekday.sat {
        color: #184FA1;
    }
    .calendar-days {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
    }
    .day-cell {
        width: calc(100% / 7);
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-family: Pretendard;
        font-size: 16px;
        font-weight: 400;
        color: #1E1E1E;
    }
    .day-cell.empty {
        cursor: default;
    }
    .day-cell.sun {
        color: #FF000F;
    }
    .day-cell.sat {
        color: #184FA1;
    }
    .day-cell.today span {
        color: #184FA1;
        font-weight: 600;
    }
    .day-cell.selected span {
        background: #184FA1;
        color: #FFFFFF;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button-area {
        width: 100%;
        margin-top: 20px;
    }
    .button-confirm {
        display: flex;
        width: 100%;
        height: 56px;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: #184FA1;
        color: #FFFFFF;
        font-family: Pretendard;
        font-size: 18px;
        font-weight: 400;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/DatePickerModal.vue